









































































































import {InOut} from 'vue-inout-prop-decorator';
import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Fournisseur} from '@/models';
import CrudAddressEdit from '@/components/Crud/Address/Edit.vue';

import storeFournisseur from '@/stores/modules/fournisseur';

import InputPhone from '@/components/Input/Phone.vue';
import InputCountry from "@/components/Input/Country.vue";
import InputZipCode from "@/components/Input/ZipCode.vue";

@Component({
	components: {
		InputPhone,
		InputCountry,
		InputZipCode,
		CrudAddressEdit,
	}
})
export default class CrudFournisseurEdit extends AbstractEditVue<Fournisseur> {

	public constructor() {
		super(
			storeFournisseur,
			'Fournisseur modifié',
			'Fournisseur créé',
		);
	}

	protected async onSubmit(): Promise<void> {
		super.onSubmit();
	}

	public async mounted(): Promise<void> {
		await super.mounted();
	}

	public async refresh(): Promise<void> {
		await super.refresh();
		//console.log('route fournisseur edit = ' + this.$route.name);
		if (this.$route.name === 'fournisseur-edit') {
			this.$route.meta.title = 'Modification  d\'un fournisseur';
		}
	}

}
